/** Created by azhou on 2019/4/1.*/
<template>
    <div>
        <ul class="list-item">
            <li class="w-50 list-item-col">{{Itemize.title}}</li>
            <li class="w-50 list-item-col flex-column">
                <span>已添加 {{Itemize.count_price_nums}} 个</span>
                <span class="text-success mt-1 mb-1">已发布 {{Itemize.total_status_1}} 个</span>
                <span class="text-danger">待审核 {{Itemize.count_price_nums - Itemize.total_status_1}} 个</span>
            </li>
            <li class="w-50 list-item-col">{{Itemize.create_time | formatTimestamp(1)}}</li>
            <li class="w-50 list-item-col" :class="Itemize.status ? 'text-success' : 'text-danger'">{{Itemize.status? '已发布' : '审核中'}}</li>
            <li class="w-50 list-item-col text-link" @click="Seek(Itemize.id)">查看</li>
        </ul>
        <el-dialog
            :title="'状态:'+Status"
            :visible.sync="dialogVisible"
            width="60%">
            <div class="d-start-around mb-2">
                <left-text leftText="活动名称"/><p class="w-100 ml-1 text-left">{{Itemize.title}}</p>
            </div>
            <div class="d-start-around mb-2">
                <left-text leftText="活动内容"/><p class="w-100 ml-1 text-left" v-html="Itemize.content"></p>
            </div>
            <div class="d-start-around mb-2">
                <left-text leftText="活动图片"/>
                <div class="w-100 ml-1 text-left">
                    <img width="80" height="60" v-lazy="ImgPreUrl + Itemize.pic" :alt="Itemize.title" :key="Itemize.id">
                </div>
            </div>
            <el-table
            :data="content.son_price_arr"
            style="width: 100%">
            <el-table-column prop="son_title" label="名称" />
            <el-table-column label="活动类型">
                <template slot-scope="scope">
                    <span v-if="scope.row.onsale_type==1">按场次</span>
                    <span v-if="scope.row.onsale_type==2">按人次</span>
                </template>
            </el-table-column>
            <el-table-column label="价格" width="200">
                <template slot-scope="scope">
                    <div>门市价：&yen;{{scope.row.price_0}}</div>
                    <div>采购商价：&yen;{{scope.row.price_1}}</div>
                </template>
            </el-table-column>
            <el-table-column label="人数限制">
                <template slot-scope="scope">
                    至少{{scope.row.min_nums+'-'+ (scope.row.max_nums>0?scope.row.max_nums:'不限')}} 人
                </template>
            </el-table-column>
            <el-table-column label="状态" width="80">
                <template slot-scope="scope">
                    <div :class="scope.row.status ? 'text-success' : 'text-danger'">
                        {{scope.row.status ? '已发布' : '待审核'}}
                    </div>
                </template>
            </el-table-column>
            </el-table>
        </el-dialog>
    </div>
  
</template>

<script>
  export default {
    name: 'HomeStayNums',
    props:{
      Itemize:{}
    },
    data () {
        return {
            dialogVisible: false,
            content: {},
        }
    },
    computed: {
        Status () {
            return this.Itemize.status? '已发布' : '审核中'
        }
    },
    methods: {
        async Seek (id) {
            let res = await this.$axios.post('pc/Homestay/getHomestayOnsaleDetails',{
                homestay_onsale_id: id,
                store_id: this.$route.query.id,
            });
            if (res.code === '00000') {
                this.content = res.info
                this.dialogVisible = true
            }
        }
    }
  }
</script>
